import translationKeys from 'translations/translationKeys';

const { msg132 } = translationKeys;
const tokenText = msg132;
export default tokenText;
